import { decodeToken, isExpired } from "react-jwt";

export const jwtIsExpired = (jwt: string) => {
  if (!jwt) {
    return true;
  }
  return isExpired(jwt);
};

export const jwtDecode = (jwt: string) => {
  return decodeToken(jwt);
};

const EMAIL_CLAIM = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";

/** E-mail do usuário logado — a única identidade do JWT que casa com o cadastro de colaborador. */
export const getEmailFromJwt = (jwt: string): string | null => {
  if (!jwt) return null;
  const decodeJwt: any = decodeToken(jwt);
  const claim = decodeJwt?.[EMAIL_CLAIM];
  return typeof claim === "string" && claim ? claim : null;
};